module.exports = __webpack_public_path__ + "static/media/loginicon.f8259b4b.svg";